export default __webpack_public_path__ + "static/media/logo.eda92375.png";